export const getSelectedFileNames = (selectedFile: File[]): string =>
  selectedFile.map((file) => file.name).join(', ');
